var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"disabled":!_vm.tooltip,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-chip',_vm._g(_vm._b({attrs:{"label":""},on:{"click":_vm.apply}},'v-chip',attrs,false),on),[_vm._v(" "+_vm._s(_vm.text)+" ")])]}}])},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }